/**
 * After any settings/save mutation: re-read active screen data (F5-like, without full reload).
 *
 * Rule: the saved value is the criterion. The UI must not keep showing a stale cache.
 * Always pass a queryKey prefix array; TanStack Query v5 requires `{ queryKey }`.
 *
 * @param {import('@tanstack/react-query').QueryClient} queryClient
 * @param {readonly unknown[]} queryKey prefix, e.g. ['building', buildingId, moduleCode]
 */
export async function refreshAfterSave(queryClient, queryKey) {
  if (!queryClient || !Array.isArray(queryKey) || !queryKey.length) return;
  await queryClient.invalidateQueries({ queryKey });
  await queryClient.refetchQueries({ queryKey, type: 'active' });
}

/** Building inspection module screens (Chiller / Calibration / other devices). */
export function buildingModuleKey(buildingId, moduleCode) {
  return ['building', buildingId, moduleCode];
}

export async function refreshBuildingModule(queryClient, buildingId, moduleCode) {
  return refreshAfterSave(queryClient, buildingModuleKey(buildingId, moduleCode));
}
